import axios from "./config";

/**
 * @function
 * @name getActivityLogs
 * @description Get activity logs with filtering options
 * @param {Object} params - Filter parameters
 * @returns {Promise}
 */
const getActivityLogs = (params = {}) => {
    return axios.get('/activity-logs', { params }).then((response) => response.data);
};

/**
 * @function
 * @name getActivityLogDetails
 * @description Get details of a specific activity log
 * @param {string|number} id - Activity log ID
 * @returns {Promise}
 */
const getActivityLogDetails = (id) => {
    return axios.get(`/activity-logs/${id}`).then((response) => response.data);
};

/**
 * @function
 * @name getActivityStats
 * @description Get activity statistics
 * @param {number} days - Number of days to get stats for (default: 30)
 * @returns {Promise}
 */
const getActivityStats = (days = 30) => {
    return axios.get('/activity-logs/stats', { params: { days } }).then((response) => response.data);
};

const auditLogsAPI = {
    getActivityLogs,
    getActivityLogDetails,
    getActivityStats,
};

export default auditLogsAPI;